import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid, FormControl, Select, Input, MenuItem,InputLabel, Divider } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import { Bar, Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Utils from '../../../providers/Utils';
import RapoarteProiect from '../../projects/RapoarteProiect';

export default class AnalizaProiectelor extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            chartProiecte: [],
            proiectId:'',



            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
            { id: 'arp', label: 'Analiza si raportare proiecte(ARP)', color: '#900DCB' }
            ]
        }
    }

    componentDidMount() {

        this.getBilantData()
        Chart.plugins.unregister(ChartDataLabels);
    }
    changeProiecte =(ev) =>{
        // console.log('ev.target.value :', ev.target.value);

        this.setState({proiectId:ev.target.value},()=>{
            this.changeProiect(ev.target.value)
        })
    }

    goBack = (id) => {
        this.props.history.push(`/${id}`)
    }

    getBilantData = async () => {
        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);


        // console.warn('listCapitole :', getData);

        if (getData.r) {



            let chartProiecte = getData.c.chartProiecte





            this.setState({
                chartProiecte: chartProiecte
            })
        }
    }
    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <div style={{ textAlign: 'left' }}>
                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goBack} />

                        )
                    })}
                </div>
                <h1 className='pm-title'>Analiza proiectelor</h1>
                <div>
                    {this.state.chartProiecte.map((cP, idx) => {

                        if (cP.chartData[0] === 0 && cP.chartData[1] === 0 && cP.chartData[2] === 0) {
                            return (
                                <div key={idx} style={{ width: '45%', display: 'inline-block' }}>
                                    <h2 className='pm-title'>{cP.titlu}</h2>
                                    <h4 style={{
                                        color: 'red',
                                        letterSpacing: 1,
                                        fontWeight: 600
                                    }}>Informatiile necesare acestui grafic nu au fost gasite</h4>

                                </div>
                            )
                        }
                        return (


                            <div style={{
                                width: '45%', display: 'inline-block',
                                position: 'relative',
                                border: '1px dashed gray',
                                marginRight: 20,
                                marginTop: 30,
                                verticalAlign: 'top'
                            }} key={idx}>
                                <h3 className='pm-title'>{cP.titlu}</h3>
                                <Bar

                                    datasetKeyProvider={() => { return Math.random() }}
                                    // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                    plugins={[ChartDataLabels]}

                                    data={{
                                        labels: cP.labels.map((r, idx2) => { return (r) }),

                                        datasets:

                                            [
                                                {
                                                    // label:r.user ,
                                                    backgroundColor: cP.labels.map((r, idx3) => { return (new Utils().culoriCharts(idx3)) }),
                                                    hoverBackgroundColor: cP.labels.map((r, idx3) => { return (new Utils().culoriCharts(idx3)) }),
                                                    data: cP.chartData.map((r) => { return (Number(r.toFixed(2))) }),

                                                }
                                            ]





                                    }}

                                    options={{

                                        onClick: function (evt, elements) {

                                            let selectedIndex = null
                                            if (elements && elements.length) {
                                                var segment = elements[0];
                                                this.update();
                                                if (selectedIndex !== segment["_index"]) {
                                                    selectedIndex = segment["_index"];
                                                    segment._model.outerRadius += 20;
                                                }
                                                else {
                                                    selectedIndex = null;
                                                }
                                            }
                                        },
                                        layout: {
                                            padding: 60,
                                            height: 300
                                        },

                                        plugins: {

                                            datalabels: {
                                                color: 'black',
                                                formatter: (value, context) => {
                                                    // console.log('value :', value);
                                                    //    console.log('context :', );
                                                    if (value > 0) {
                                                        return value
                                                    } else {
                                                        return ''
                                                    }


                                                },
                                                font: {
                                                    size: 13,
                                                    weight: 600
                                                },
                                                align: 'end',
                                                clamp: true


                                            },

                                        },
                                        legend: {
                                            display: false
                                        }
                                    }}

                                />
                            </div>

                        )
                    })}
                    <FormControl className='inputFocus' style={{ width: '30%', margin: 'auto', marginTop: 20, marginBottom: 80 }}>
                        <InputLabel htmlFor="proiect">Selecteaza Proiect</InputLabel>
                        <Select

                            value={this.state.proiectId || ""}
                            onChange={this.changeProiecte}

                            input={<Input id="proiect" />}>


                            {this.state.chartProiecte.map((s, idx) => {
                                return <MenuItem value={s.id} key={idx}  > {s.titlu}</MenuItem>

                            })
                            }
                        </Select>
                    </FormControl>


                    <Divider className='pm-divider' />


                    {this.state.proiectId &&
                        <RapoarteProiect idproiect={this.state.proiectId}
                            onChangeEvent={c => this.changeProiect = c} />
                    }

                </div>

            </div>
        );
    }
}